module.exports = __webpack_public_path__ + "static/media/paok24.8e903fba.png";